import { useEffect } from 'react';
import { usePlayer, useSource } from '../components';

export const useMediaSessionActionHandlers = () => {
  const { items, currentItemId } = useSource();
  const { next, prev, togglePlaying, loopPlaylist } = usePlayer();

  useEffect(() => {
    if (!navigator.mediaSession?.metadata || !items.length) {
      return;
    }

    const noPreviousTrack = !currentItemId && !loopPlaylist;
    const noNextTrack = currentItemId === items.length - 1 && !loopPlaylist;

    const directions = ['next', 'previous'] as const;
    directions.forEach((type) => {
      const [noCallbackCondition, callback] =
        type === 'next' ? [noNextTrack, next] : [noPreviousTrack, prev];

      navigator.mediaSession.setActionHandler(
        `${type}track`,
        noCallbackCondition ? null : callback
      );
    });

    return () => {
      directions.forEach((type) => {
        navigator.mediaSession.setActionHandler(`${type}track`, null);
      });
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [
    items,
    currentItemId,
    loopPlaylist,
    next,
    prev,
    navigator.mediaSession?.metadata
  ]);

  useEffect(() => {
    if (!navigator.mediaSession) {
      return;
    }

    const playbackActions = ['play', 'pause'] as const;
    playbackActions.forEach((type) => {
      navigator.mediaSession.setActionHandler(type, () => {
        togglePlaying(type === 'play');
      });
    });

    return () => {
      playbackActions.forEach((type) => {
        navigator.mediaSession.setActionHandler(type, null);
      });
    };
  }, [togglePlaying]);
};
